/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import store from './app';
import Plyr from 'plyr';
( function( app ) {
  const COMPONENT = {
    init: function() {
      window.debounce = require( 'lodash/debounce' );
      $( '.navbar .dropdown-toggle' ).on( 'toggleAfter', ( event ) => {
        const togglePos = $( event.target ).position();
        const toggleWidth = $( event.target ).width();
        $( $( event.target ).attr( 'data-toggle-target' ) ).find( '.toggle-arrow' ).css( 'left', ( togglePos.left + ( toggleWidth / 2 ) ) );
      } );

      if ( $( document ).scrollTop() > 1 ) {
        $( '.navbar' ).addClass( 'is-shrunk' );
        $( '.return-to-top' ).addClass( 'is-visible' );
      }

      $( document ).scroll( function() {
        const el = $( '.navbar' );
        const top = $( document ).scrollTop();
        if ( top > 1 && !el.is( '.is-shrunk' ) ) {
          $( el ).addClass( 'is-shrunk' );
          $( '.return-to-top' ).addClass( 'is-visible' );
        } else if ( top <= 1 ) {
          $( el ).removeClass( 'is-shrunk' );
          $( '.return-to-top' ).removeClass( 'is-visible' );
        }
      } );

      $( '.return-to-top' ).click( function() {
        if ( window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
          $( 'html, body' ).animate( {scrollTop: 0}, 0 );
        } else {
          $( 'html, body' ).animate( {scrollTop: 0}, 'slow' );
        }

        setTimeout( function() {
          $( 'main > *:first-child' ).focus();
        }, 1000 );
        return false;
      } );


      // Search modal
      $( '.navbar-search' ).magnificPopup( {
        type: 'inline',
        preloader: false,
        focus: '.search-overlay__input',
        autoFocusLast: true,
        modal: true,
      } );
      $( document ).on( 'click', '.search-overlay__close', function( e ) {
        e.preventDefault();
        $.magnificPopup.close();
      } );
      $( document ).on( 'click', '.mobile-search-btn', function( e ) {
        e.preventDefault();
        $( '.navbar-search' ).trigger( 'click' );
      } );


      if ( !sessionStorage.getItem( 'us_nav_alert_banner_dismissed', 'true' ) ) {
        $( '.navbar .alert-banner' ).show();
        $( '.navbar .alert-banner' ).addClass( 'is-visible' );
      }

      $( '.navbar .alert-banner .close-alert' ).click( function() {
        $( '.navbar .alert-banner' ).hide();
        $( ':root' ).css( '--alertBannerHeight', `0px` );
        sessionStorage.setItem( 'us_nav_alert_banner_dismissed', 'true' );
      } );

      const $alertBanner = $( '.navbar .alert-banner.is-visible' );

      function alertBannerHeight() {
        if ( $alertBanner.length ) {
          const alertBannerHeight = $alertBanner.outerHeight();
          $( ':root' ).css( '--alertBannerHeight', `${alertBannerHeight}px` );
        }
      }

      alertBannerHeight();

      $( window ).on( 'resize', debounce( function() {
        alertBannerHeight();
      }, 100 ) );


      $( '.team-filter-form' ).on( 'submit', function( event ) {
        event.preventDefault(); // Prevent actual form submission
        const formData = new FormData( this );
        const url = formData.get( 'filter-select' );
        if ( url ) {
          window.location.href = url; // Redirect to the selected URL
        }
      } );

      $( document ).on( 'click', '.js-init-video', function( e ) {
        e.preventDefault();
        // get the title from data attribute added to button
        // console.log( .data( 'title' ) );
        const title = $( e.target ).data( 'title' );
        $.magnificPopup.open( {
          items: {
            src: $( this ).attr( 'href' ),
          },
          type: 'iframe',
          mainClass: 'mfp-fade',
          focus: '.mfp-close',
          closeBtnInside: true,
          autoFocusLast: true,
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          closeMarkup: '<button aria-label="%title%" type="button" class="mfp-close ll-custom-close">×</button>',
          callbacks: {
            open: function() {
              // get the current instance of the magnificPopup
              const currentMagnificPopup = $.magnificPopup.instance;

              // add title to the container aria label
              currentMagnificPopup.contentContainer.attr( 'role', 'dialog' );

              if ( title !== undefined ) {
                // get the current iframe element
                const currIframe = currentMagnificPopup.currTemplate.iframe.find( 'iframe' );
                // add title to the iframe and container
                currIframe.prop( 'title', title );
                currentMagnificPopup.contentContainer.attr( 'aria-label', `${title} player` );
              }

              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      $( '.js-init-image' ).magnificPopup( {
        type: 'image',
        mainClass: 'mfp-fade',
        focus: '.mfp-close',
        autoFocusLast: true,
        fixedContentPos: true,
        fixedBgPos: true,
        preloader: false,
        closeMarkup: '<button aria-label="%title%" type="button" class="mfp-close ll-custom-close">×</button>',
        image: {
          markup: '<div class="mfp-figure" aria-modal="true" role="dialog">'+
          '<div class="mfp-close"></div>'+
          '<figure>'+
          '<div class="mfp-img"></div>'+
          '<figcaption>'+
          '<div class="mfp-title wysiwyg"></div>'+
          '</figcaption>'+
          '</figure>'+
        '</div>',
          cursor: 'mfp-zoom-out-cur',
          titleSrc: function( item ) {
            return item.el.attr( 'data-caption' );
          },

        },
      } );

      // const player = null;
      // $( '.video-popup-button' ).magnificPopup( {
      //   type: 'inline',
      //   mainClass: 'mfp-fade',
      //   removalDelay: 160,
      //   preloader: false,
      //   fixedContentPos: false,
      // } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        // $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
        $( '.primary-toggle.navbar-toggle.is-open' ).trigger( 'click' );

        if ( window.isMobile ) {
          console.log( 'its mobile' );
          $( '.footer-menu-toggle' ).removeAttr( 'disabled' );
          $( '.footer-menu-toggle' ).trigger( 'click' );
        } else {
          $( '.footer-menu-toggle:not(.is-open)' ).trigger( 'click' );
          $( '.footer-menu-toggle' ).prop( 'disabled', true );
        }
      } );

      if ( window.isMobile ) {
        $( '.footer-menu-toggle' ).removeAttr( 'disabled' );
      } else {
        $( '.footer-menu-toggle' ).trigger( 'click' );
        $( '.footer-menu-toggle' ).prop( 'disabled', true );
      }


      // trap focus on mobile
      $( '.primary-nav--mobile .child-dropdown, .level-one:not(is-open)' ).on( 'keyup', function( event ) {
        if ( event.key !== 'Tab' ) return;

        const $focusableElements = $( this ).find(
            'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
        );

        if ( $focusableElements.length === 0 ) return;

        const firstElement = $focusableElements.first();
        const lastElement = $focusableElements.last();

        if ( event.shiftKey && $( document.activeElement ).is( firstElement ) ) {
          event.preventDefault();
          lastElement.focus();
        } else if ( !event.shiftKey && $( document.activeElement ).is( lastElement ) ) {
          event.preventDefault();
          firstElement.focus();
        }
      } );

      // close nav on desk top when user is outside main nav
      // $( '#primary-nav-desktop, .secondary-menu-links' ).on( 'focusout', function( event ) {
      //   if ( !$( this ).has( event.relatedTarget ).length ) {
      //     const isOpen = $( this ).find( '.dropdown-toggle.is-open' );
      //     if ( isOpen.length ) {
      //       isOpen.trigger( 'click' );
      //     }
      //   }
      // } );

      let navHeight = $( '.navbar' ).outerHeight();
      let blogFiltersPos = $( '.blog-filters' ).outerHeight();

      if ( $( '#wpadminbar' ).length ) {
        navHeight += $( '#wpadminbar' ).outerHeight();
      }

      blogFiltersPos += navHeight;

      // close nav on desk top when user is outside main nav
      $( '#blog-nav' ).on( 'focusout', function( event ) {
        if ( !$( this ).has( event.relatedTarget ).length ) {
          const isOpen = $( this ).find( '.blog-filter__button.is-open' );
          if ( isOpen.length ) {
            isOpen.trigger( 'click' );
          }
        }
      } );

      $( '.close-dropdown' ).on( 'click', function( event ) {
        $( $( event.currentTarget ).attr( 'data-close' ) ).trigger( 'click' );
        return $( $( event.currentTarget ).attr( 'data-close' ) ).focus();
      } );


      // Footer


      // $( '.blog-filters' ).css( 'top', navHeight );


      // $( document ).on( 'click', '.buy-tickets-trigger', function( e ) {
      //   const n = $( e.target ).data( 'id' );

      //   $.post(
      //       site_info.ajax_url,
      //       {
      //         action: 'll_run_function',
      //         function: 'get_next_event_session_date',
      //         params: {
      //           event_id: n,
      //         },
      //       },
      //       function( data, textStatus, xhr ) {
      //         data = $.parseJSON( data );
      //         if ( data.status === 'success' ) {
      //           // const date = new Date( data.response );
      //           let date = false;

      //           if ( data.response ) {
      //             date = new Date( data.response + 'T00:00:00' );
      //           } else {
      //             date = new Date();
      //           }

      //           store.commit( 'setSelectedEvent', {n, date} );

      //           if ( ! $( '#buy-tickets' ).hasClass( 'is-open' ) ) {
      //             $( '.buy-tickets-button' ).first().click();
      //           }
      //         }
      //       }
      //   );
      // } );

      // $( document ).on( 'click', '.buy-merchandise-trigger', function( e ) {
      //   const n = $( e.target ).data( 'id' );

      //   store.commit( 'setSelectedMerchandise', {n} );

      //   if ( $( '#buy-tickets' ).hasClass( 'is-open' ) ) {
      //     $( '.buy-tickets-button' ).first().click();
      //   }
      //   if ( $( '#sidebar-cart' ).hasClass( 'is-open' ) ) {
      //     $( '.sidebar-cart-button' ).first().click();
      //   }
      //   $( '.buy-merchandise-button' ).first().click();
      // } );

      // $( document ).click( function( e ) {
      //   const target = $( e.target );
      //   if ( $( '#buy-tickets' ).hasClass( 'is-open' ) && $.contains( e.target, document.querySelector( '#buy-tickets' ) ) ) {
      //     $( '.buy-tickets-button' ).first().click();
      //   }
      // } );
    },
    finalize: function() {
      // Fix window position for fixed nav on jump link
      if ( window.location.hash ) {
        const oldScrollPos = $( window ).scrollTop();
        let navHeight = $( '.navbar' ).outerHeight();

        if ( $( '#wpadminbar' ).length ) {
          navHeight += $( '#wpadminbar' ).outerHeight();
        }

        window.scrollTo( 0, oldScrollPos - navHeight );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
